import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import { SHARE_BINDING_STATUS } from '@src/constants/FJShareSocialConstant.ts';
import FJAccountList from '@src/components/FJModals/FJShareModal/FJAccount/FJAccountList.tsx';
import FJPublishAction from '@src/redux/action/FJPublishAction.ts';

const FJAccountListContainer = () => {
    const dispatch = useAppDispatch();
    const list = useAppSelector(state => {
        return [state.share.youtube, state.share.linkedin];
    });
    const selectedShareTypes = useAppSelector(state => state.share.selectedShareTypes);
    const publishedTypes = useAppSelector(state => state.share.publishedTypes);
    const failedTypes = useAppSelector(state => state.share.failedTypes);
    const linkedinError = useAppSelector(state => state.share.linkedinError);

    const linkedList = list.filter(item => item.linkAccountState === SHARE_BINDING_STATUS.LINKED);

    const showAddAccountPanel = () => {
        dispatch(FJPublishAction.openAddAccountPanelAction());
    };

    const onSelect = (shareType: string) => {
        dispatch(FJPublishAction.selectPublishTargetAction(shareType));
    };

    return (
        <FJAccountList
            list={linkedList}
            selectedShareTypes={selectedShareTypes}
            publishedTypes={publishedTypes}
            failedTypes={failedTypes}
            addAccount={linkedList.length !== list.length ? showAddAccountPanel : undefined}
            onSelect={onSelect}
            linkedinError={linkedinError}
        />
    );
};

export default FJAccountListContainer;
